import { render, staticRenderFns } from "./ApplicationTrendChart.vue?vue&type=template&id=55e04cc8"
import script from "./ApplicationTrendChart.vue?vue&type=script&lang=js"
export * from "./ApplicationTrendChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports